module.exports = __webpack_public_path__ + "img/bring-the-users.ea3eaeec.jpg";